import { defaultAxios, IParams } from './base';

export interface IGetCustPreProductList extends IParams {
  custSeq?: number;
}

export const getCustPreProductList = (params: IGetCustPreProductList) => {
  return defaultAxios().post(`/cust/v1/pre/product/list`, params);
};
